import { useEffect, useContext, useState } from "react";
import { useSelector } from "react-redux";
import bbox from "@turf/bbox";
import { TRANSITION_EVENTS } from "deck.gl";
import { LinearInterpolator, WebMercatorViewport } from "react-map-gl";

import { ViewStateContext } from "../UrlParser/UrlParser";
import { aoiCategories } from "../../config/config.aoi";

function ChangeView() {
  // currently on initial render, AOI gets priority over map center/zoom
  const aoiState = useSelector((state) => state.aoi);
  const dataState = useSelector((state) => state.data);
  const { viewState, setViewState } = useContext(ViewStateContext);

  const selectedEntity = useSelector(
    (state) => state.dataExplorer.selectedEntity
  );
  const filters = useSelector(
    (state) => state.dataExplorer.filters[selectedEntity]
  );

  const [transitioning] = useState(false);
  const dataId = aoiCategories.find(
    (aoiCat) => aoiCat.id === aoiState.selection.category
  )?.data;

  // beyond initial render, fly to AOI when aoi updates
  useEffect(() => {
    const aoiData = aoiState.selection.category
      ? dataState[
          aoiCategories.find(
            (aoiCat) => aoiCat.id === aoiState.selection.category
          ).data
        ].data
      : null;

    if (
      aoiState.selection.category &&
      aoiState.selection.selectedIds.length > 0 &&
      aoiData
    ) {
      if (!filters.ngwos_basin) {
        return;
      }
      const allBBs = filters.ngwos_basin
        ?.map((basin) =>
          dataState[dataId].data.features.find(
            (feat) => feat.properties.Basins_ShortName === basin
          )
        )
        .filter((object) => object)
        .map((object) => bbox(object));

      if (allBBs.length === 0) {
        return;
      }
      const minX = allBBs
        .map((bb) => bb[0])
        .flat()
        .reduce((prev, curr) => (prev < curr ? prev : curr));
      const minY = allBBs
        .map((bb) => bb[1])
        .flat()
        .reduce((prev, curr) => (prev < curr ? prev : curr));
      const maxX = allBBs
        .map((bb) => bb[2])
        .flat()
        .reduce((prev, curr) => (prev > curr ? prev : curr));
      const maxY = allBBs
        .map((bb) => bb[3])
        .flat()
        .reduce((prev, curr) => (prev > curr ? prev : curr));

      const webMercatorViewport = new WebMercatorViewport(viewState);
      if (!transitioning) {
        const { longitude, latitude, zoom } = webMercatorViewport.fitBounds(
          [
            [minX, minY],
            [maxX, maxY],
          ],
          { padding: 50 }
        );

        // Zoom to the object
        setViewState((prevState) => {
          return {
            ...prevState,
            longitude,
            latitude,
            zoom,
            transitionDuration: 1000,
            transitionInterruption: TRANSITION_EVENTS.SNAP_TO_END,
            transitionInterpolator: new LinearInterpolator(),
            // onTransitionStart: () => setTransitioning(true),
            // onTransitionEnd: () => setTransitioning(false),
            onTransitionInterrupt: () => console.log("TRANSITION INTERRUPTED"),
          };
        });
      }
    }
  }, [aoiState.selection.selectedIds]);

  return null;
}

export default ChangeView;
